/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextArea
 * root Object
 * @param {com.inq.ui.TextArea} chatWindow
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextArea = function(chatWindow) {
	this._ta = null;
	this._setHtmlText("");
	this._tabStops = null;
	this._textField = null;
	this._initialized = false;
	this._onInitialized = null;
	this.arrayOpeners = [];
	// store active chat messages
	this.arrayTranscripts = [];
	// store completed conversations and chats messages
	this.historicTranscriptsArray = [];
	if (null != chatWindow) {
		this._textArea = chatWindow;
	}
	this._ta = chatWindow;
	this._indent = 80;
	this._renderTimer = null;
	this._resetRestoreChatTimer = null;
	/** @type {com.inq.ui.CustomerNameInputField[]} */
	this._inset = [];
	this._wasCleared = false;
	/**
	 * This flag (switcher) shows that transcript scroll position is at bottom or not.
	 * True by default, since chat window doesn't have scrollbar at initialisation
	 * @type {boolean}
	 */
	this.atBottom = true;
	this.setTabStops();
	this.enableTranscriptTimestamp = com.inq.utils.Util.getConfig("enableTranscriptTimestamp", false);
	this.transcriptTimestampFormat = this.getDateFormatConfig(this.defaultTranscriptTimestampFormat, "transcriptTimestampFormat");
	this.transcriptDateFormat = this.getDateFormatConfig(this.defaultTranscriptDateFormat, "transcriptDateFormat");
	this.todayLabel = com.inq.utils.Util.getConfig("todayLabel", this.TODAY_LABEL);
	this.applyStyles();
	this.reverseChat = com.inq.utils.Util.getConfig("reverseChat",false);
	this.autoScrollDisabled = com.inq.utils.Util.getConfig("autoScrollDisabled", false);
	this.enhancedScrollingEnabled = com.inq.utils.Util.getConfig("enhancedScrollingEnabled", false);
	/** @type {com.inq.ui.Button} */
	this.scrollBtn = Application.application.getMxmlItem("scrollBtn");
	this.bindListenerToScrollBtn();
	this.bindListenerToChatWindow();
};
$hxClasses['com.inq.flash.client.chatskins.ChatTextArea'] = com.inq.flash.client.chatskins.ChatTextArea;
/** @private @type {Array} */
com.inq.flash.client.chatskins.ChatTextArea.__name__ = ["com","inq","flash","client","chatskins","ChatTextArea"];

/**
 * setStyle
 *
 * $type TFun([{ name => styleName, t => TInst(String,[]), opt => false },{ name => styleValue, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setStyle(styleName:String, styleValue:String)
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {string}  styleName
 * @param {string}  styleValue
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.setStyle = function(styleName,styleValue) {
	if(this._ta != null) this._ta.setStyle(styleName,styleValue);
};


/**
 * getTranscriptMessage
 *
 * $type TFun([{ name => index, t => TInst(Int,[]), opt => false }],TInst(String,[]))
 * public function getTranscriptMessage( index:Int )
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {number}  index
 * @return {string}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getTranscriptMessage = function(index) {
	return this.arrayTranscripts[index];
};


/**
 * replaceTranscriptLineNoRender
 * replace string in cache without rendering the html
 *
 * $type TFun([{ name => index, t => TInst(Int,[]), opt => false },{ name => newLine, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {number}  index -  index of string
 * @param {string}  newLine -  string to replace
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.replaceTranscriptLineNoRender = function(index,newLine) {
	if(index < 0 || index > this.arrayTranscripts.length) return false;
	this.arrayTranscripts[index]["Msg"] = newLine;
	return true;
};


/**
 * replaceTranscriptLine
 * replace string in cache and rerender the html.
 *
 * $type TFun([{ name => index, t => TInst(Int,[]), opt => false },{ name => newLine, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {number}  index -  index of string
 * @param {string}  newLine -  string to replace
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.replaceTranscriptLine = function(index,newLine) {
	if(this.replaceTranscriptLineNoRender(index,newLine)) this.render();
};

/**
 * updateTranscriptArray
 * update element inside transcripts array
 *
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {Node}  element -  that has been modified
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.updateTranscriptArray = function(element) {
	/** @type {HTMLElement} */
	var div = window.document.createElement("DIV");
	/** @type {?string} */
	var elementID = null;
	/** @type {?Node} */
	var p = element.parentNode;
	while (p != null) {
		if (p.tagName == "SPAN") break;
		p = p.parentNode;
	}
	if (p != null) {
		elementID = p.id;
		try {
			for (var i=0; i < this.arrayTranscripts.length; i++) {

				if (this.arrayTranscripts[i]["Msg"]) {
					div.innerHTML = this.arrayTranscripts[i]["Msg"];
					/** @type {NodeList} */
					var elements = div.getElementsByTagName("SPAN");

					for (var j = 0; j < elements.length; j++) {
						/** @type {js.HtmlDom} */
						var  el = elements[j];
						if (el.id != elementID) {
							continue;
						}
						if (el.innerHTML == p.innerHTML) {
							return;
						}
						el.innerHTML = p.innerHTML;
						this.replaceTranscriptLine(i, div.innerHTML);
						return;
					}
				}
			}
		} catch( e ) {
			haxe.Log.trace("Error:" + Std.string(e),{ fileName : "ChatTextArea.hx", lineNumber : 554, className : "com.inq.flash.client.chatskins.ChatTextArea", methodName : "updateTranscriptArray"});
		}
	}
};

/**
 * getTranscriptLine
 * get transcript string by index
 * else - string
 *
 * $type TFun([{ name => index, t => TInst(Int,[]), opt => false }],TInst(String,[]))
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {number}  index -  index of string
 * @return {string} - nul, index is wrong
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getTranscriptLine = function(index) {
	if(index < 0 || index > this.arrayTranscripts.length) return null;
	return this.arrayTranscripts[index]["Msg"];
};


/**
 * findTranscriptLineIndex
 * define index of firts string in cache, which has sub string
 * else - index of first corresponded string
 *
 * $type TFun([{ name => subString, t => TInst(String,[]), opt => false }],TInst(Int,[]))
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {string}  subString -  sub string
 * @return {number} - 1 , if there is no corresponded string in cache,
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.findTranscriptLineIndex = function(subString) {
	var /** @type {*} */ o;
	var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = this.arrayTranscripts.length;
	while(_g1 < _g) {
		var /** @type {number} */ i = _g1++;
		o = this.arrayTranscripts[i];
		if(null != o) try {
			if(o["Msg"].length > 0) {
				if(o["Msg"].indexOf(subString) != -1) return i;
			}
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
			} else throw(e);
		}
	}
	return -1;
};


/**
 * getHtmlText
 *
 * $type TFun([],TInst(String,[]))
 * private function getHtmlText():String
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {string}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getHtmlText = function() {
	return this.__htmlText;
};

/**
 * addTranscriptLine
 *
 * $type TFun([{ name => Id, t => TInst(String,[]), opt => false },{ name => Msg, t => TInst(String,[]), opt => false },{ name => MsgType, t => TInst(Int,[]), opt => false },{ name => _html, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private function addTranscriptLine (Id:String, Msg:String, MsgType:Int, _html:String):String
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {string}  msgOwner - A message owners name or alias
 * @param {string}  chatLine - message content
 * @param {number}  msgId - message id in chat window
 * @param {number}  msgType - type of message (Agent/Customer/System)
 * @param {string}  htmlStr - HTML content
 * @param {String} cssClass - By default value is for Live Agent and addAgentTypeCss configuration value in skin
 * @param {string=} timeMarker - Time marker of message
 * @param {string=} newDay optional parameter. Comes when the conversation changes the day.
 * @return {string}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.addTranscriptLine = function(msgOwner, chatLine, msgId, msgType, htmlStr, cssClass, timeMarker, newDay) {
	/** @type {string} */
	var defaultAgentAlias = com.inq.utils.Util.getConfig("defaultAgentAlias", "");
	/** @type {string} */
	var usecolon = defaultAgentAlias == "" && msgOwner == "&nbsp;"?"":":";
	/** @type {string} */
	var sText = chatLine;
	/** @type {string} */
	var agentIdPfx;
	/** @type {string} */
	var msgTime = "";
	/** @type {string} */
	var msgNewDay = "";
	/** @type {Array}*/
	var timeMarkerArray = new Array();
	/** Contains numerical part of timestamp*/
	var numericalTimeMarker = "";
	/** @type {string} Span element which contains am/pm part of timestamp*/
	var period = "";
	/** @type {string} Span element which contains numerical part of today's message timestamp*/
	var todayMsgTime = "";
	if (timeMarker) {
		timeMarkerArray = timeMarker.split(" ");
		numericalTimeMarker = timeMarkerArray.shift();
		period = this.PERIOD_PFX + timeMarkerArray + this.PERIOD_SFX;
		todayMsgTime = this.TODAY_MSG_TIME_PFX + numericalTimeMarker + period + this.TODAY_MSG_TIME_SFX;
	}

	if (newDay && this.enableTranscriptTimestamp) {
		if (newDay === this.todayLabel) {
			msgNewDay = this.MSG_NEW_TODAY_DATE_DIV_PFX + this.MSG_NEW_TODAY_DATE_SPAN_PFX + newDay + this.MSG_NEW_TODAY_DATE_SPAN_SFX + todayMsgTime + this.MSG_NEW_TODAY_DATE_DIV_SFX;
		} else {
			msgNewDay = this.MSG_NEW_DAY_PFX + newDay + this.MSG_NEW_DAY_SFX;
		}
	}

	switch(msgType) {
		case com.inq.flash.client.chatskins.ChatTextArea.AGENT:
			/* This replace is necessary because "defaultAgentAlias" could be already been stored in mxml as encoded string
			* . i.e. "AT&amp;T"
			* */
			msgOwner = StringTools.htmlUnescape(msgOwner);
			chatLine = chatLine.split("&apos;").join("'");
			/* When Id is empty, the agentId span element empty */
			agentIdPfx = com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_PFX;

			if (com.inq.utils.Util.getConfig("addAgentTypeCss", false)) {
				agentIdPfx = agentIdPfx.replace(com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_CLASS_NAME,
					com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_CLASS_NAME + " " + (cssClass ? cssClass : com.inq.flash.client.chatskins.ChatTextArea.AGENT_DEFAULT_CLASS_NAME));
			}
			if (usecolon == ":") {
				msgOwner = agentIdPfx + msgNewDay + this.AGENT_ID_SPAN + msgOwner + usecolon + com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_SFX;
			} else {
				msgOwner = agentIdPfx + com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_SFX.split("&nbsp;").join("");
			}

			msgTime = this.AGENT_MSG_TIME_PFX + numericalTimeMarker + period + this.AGENT_MSG_TIME_SFX;
			/*  Still need tr without &nbsp; from AGENT_ID_SFX */
			chatLine = com.inq.flash.client.chatskins.ChatTextArea.AGENT_MSG_PFX + chatLine
				+ com.inq.flash.client.chatskins.ChatTextArea.AGENT_MSG_SFX.replace(com.inq.flash.client.chatskins.ChatTextArea.MESSAGE_ID_REPLACEMENT, msgId)
				+ com.inq.flash.client.chatskins.ChatTextArea.MSG_SFX;

			if (this.enableTranscriptTimestamp) {
				sText = msgOwner + msgTime + chatLine;
			} else {
				sText = msgOwner + chatLine;
			}
			break;
		case com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER:
			msgTime = this.CUST_MSG_TIME_PFX + numericalTimeMarker + period + this.CUST_MSG_TIME_SFX;
			msgOwner = com.inq.flash.client.chatskins.ChatTextArea.CUST_ID_PFX + msgNewDay + this.CUST_ID_SPAN + msgOwner + com.inq.flash.client.chatskins.ChatTextArea.CUST_ID_SFX;
			chatLine = com.inq.flash.client.chatskins.ChatTextArea.CUST_MSG_PFX + chatLine + com.inq.flash.client.chatskins.ChatTextArea.CUST_MSG_SFX;
			if (this.enableTranscriptTimestamp) {
				sText = msgOwner + msgTime + chatLine;
			} else {
				sText = msgOwner + chatLine;
			}
			break;
		case com.inq.flash.client.chatskins.ChatTextArea.SYSTEM:
			chatLine = chatLine.split("\n").join("<br/>");
			var sysPFX = com.inq.flash.client.chatskins.ChatTextArea.SYS_PFX;
			/*
			 * RTDEV-17612
			 * If cssClass was specified, append it the class attribute of system message.
			 */
			if (cssClass) {
				var length = sysPFX.indexOf("systemMsg") + "systemMsg".length;
				sysPFX = sysPFX.slice(0, length) + " " + cssClass + sysPFX.slice(length);
			}
			chatLine = sysPFX + chatLine + com.inq.flash.client.chatskins.ChatTextArea.SYS_SFX;
			sText = chatLine;
			break;
		case com.inq.flash.client.chatskins.ChatTextArea.SEPARATOR:
			sText = this.SEPARATOR_TR;
			break;
		case com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_STATUS:
		case com.inq.flash.client.chatskins.ChatTextArea.FORM_STATUS:
			chatLine = com.inq.flash.client.chatskins.ChatTextArea.SYSSTAT_PFX + chatLine + com.inq.flash.client.chatskins.ChatTextArea.SYSSTAT_SFX;
			sText = chatLine;
			break;
		case com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_INFO:
			/* This replace is necessary because "defaultAgentAlias" could be already been stored in mxml as encoded string
			* . i.e. "AT&amp;T"
			* */
			msgOwner = StringTools.htmlUnescape(msgOwner);
			if (msgOwner) {
				msgOwner = com.inq.flash.client.chatskins.ChatTextArea.SYSINF_ALIAS_PFX + msgOwner + usecolon + com.inq.flash.client.chatskins.ChatTextArea.SYSINF_ALIAS_SFX;
			}
			chatLine = com.inq.flash.client.chatskins.ChatTextArea.SYSINF_PFX + msgOwner + com.inq.flash.client.chatskins.ChatTextArea.SYSINF_MESSAGE_PFX + chatLine + com.inq.flash.client.chatskins.ChatTextArea.SYSINF_MESSAGE_SFX + com.inq.flash.client.chatskins.ChatTextArea.MSG_SFX;
			sText = chatLine;
			break;
		case com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA:
			msgTime = this.CUST_MSG_TIME_PFX + numericalTimeMarker + period + this.CUST_MSG_TIME_SFX;
			msgOwner = com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA_ID_PFX + msgNewDay;
			chatLine = com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA_MSG_PFX + chatLine + com.inq.flash.client.chatskins.ChatTextArea.CUST_MSG_SFX;

			if (this.enableTranscriptTimestamp) {
				sText = msgOwner + msgTime + chatLine;
			} else {
				sText = msgOwner + chatLine;
			}
			break;
	}

	sText = com.inq.flash.client.chatskins.ChatTextArea.prototype.checkCssFirstInMessageGroup(sText, msgType);

	htmlStr = this.reverseChat?sText + htmlStr:htmlStr + sText;/*  Render chat in reverse chronological order?*/

	return htmlStr;
};

com.inq.flash.client.chatskins.ChatTextArea.prototype.lastMessageType = null;

/**
 * Adds first_in_group into Agents and Customers' messages when a message is the first in a group
 * @param sText HTML contains a message.
 * @param msgType message type. Agent message 1, Customer message 2
 * @returns {string|void|*}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.checkCssFirstInMessageGroup = function (sText, msgType) {
	if (msgType === 1 || msgType === 2) {
		try {
			if (com.inq.flash.client.chatskins.ChatTextArea.prototype.lastMessageType !== msgType) {
				sText = com.inq.flash.client.chatskins.ChatTextArea.prototype.addCssFirstInMessageGroup(sText);
			}
		} catch (errLastMsg) { /* Ignore any exceptions */
		}
		com.inq.flash.client.chatskins.ChatTextArea.prototype.lastMessageType = msgType;
	}
	return sText;
};

/**
 * Adds first_in_group into Agents and Customers' messages
 * @param sText
 * @returns {string|void|*}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.addCssFirstInMessageGroup = function (sText) {
	// find <tr><td
	if (sText.indexOf("<tr><td") === 0) {
		if (sText.indexOf("td class='") !== -1) {
			// if it has class then add "first_in_group" into existing class.
			return sText.replace("td class='", "td class='first_in_group ");
		} else {
			return sText.replace("<tr><td", "<tr><td class='first_in_group'");
			// if it doesnt' has class add class="first-in-group"
		}
	}
	return sText;
};

/**
 * Used to queue initial aria messages
 * @depricated
 * @param Id
 * @param Msg
 * @param MsgType
 * @param force
 */

com.inq.flash.client.chatskins.ChatTextArea.prototype.addBufferedAriaMsg = function(Id, Msg, MsgType, force) {
	com.inq.aria.AriaMsg.addBufferedAriaMsg(Id, Msg, MsgType, force);
};

/**
 * addTranscript
 *
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {string}  Id
 * @param {string}  Msg
 * @param {number}  MsgType
 * @param {number}  position
 * @param {Array} expressionList
 * @param {string} restoreMode
 * @param {String} cssClass - If specified, append it to the "class" attribute of the systemMsg.  RTDEV-17612
 * @param {Date=} messageTimestamp
 * @return {number}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.addTranscript = function(Id,Msg,MsgType,position, expressionList, restoreMode, cssClass, messageTimestamp) {
	/** @type {number} */
	var res = -1;

	this.removeSystemMessageFromTranscript();

	try {
		/** @type {boolean} Indicates that we already have the same message
		 *  on this position added by {@link ApplicationController.sendButtonClicked}
		 */
		var messageExists = !restoreMode && this._isCustomerOrSystemMessage(position);

		/** @type {object} */
		var newMessage = this.buildTranscriptMessage(this.arrayTranscripts, this.historicTranscriptsArray, Id, Msg, MsgType, position, messageExists, cssClass, messageTimestamp);

		// check if we already have the same customer message(added by ApplicationController#sendButtonClicked) on this position
		if (messageExists) {
			this.arrayTranscripts[position] = newMessage;
			res = position;
		} else {
			this.arrayTranscripts.push(newMessage);
			res = this.arrayTranscripts.length - 1;
		}

		// newMessage - it is the link to the object which was added to the arrayTranscripts,
		// therefore we can continue to work with it and change it
		newMessage["msgId"] = com.inq.flash.client.chatskins.ChatTextArea.MSG_ID_PREFIX + res; // used only in agent message

		this.prepareExpressionForRender(expressionList, newMessage["msgId"]);
		this.render();
	} catch (e) {
		haxe.Log.trace(
			"ChatTextArea.addTranscript Error:" + Std.string(e),
			{
				fileName : "ChatTextArea.js",
				className : "com.inq.flash.client.chatskins.ChatTextArea",
				methodName : "addTranscript"
			}
		);
	}

	return res;
};

/**
 * Removes system message from transcript if it is a top message
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.removeSystemMessageFromTranscript = function () {
	if (this.arrayTranscripts.length > 0) {
		/** @type {object} */
		var lastMessage = this.arrayTranscripts[this.arrayTranscripts.length - 1];

		if (lastMessage["MsgType"] === com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_STATUS) {
			this.arrayTranscripts.pop();
		}
	}
};

/**
 * Removes system message from transcript and rerender chat messages
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.removeSystemMessageAndRerender = function () {
	this.removeSystemMessageFromTranscript();

	try {
		this.render();
	} catch (e) {
		haxe.Log.trace(
			"ChatTextArea.removeSystemMessageAndRerender Error:" + Std.string(e),
			{
				fileName : "ChatTextArea.js",
				className : "com.inq.flash.client.chatskins.ChatTextArea",
				methodName : "removeSystemMessageAndRerender"
			}
		);
	}
};

/**
 * Adds message to the historic transcript array. Doesn't render transcript
 *
 * @param {string}  id
 * @param {string}  msg
 * @param {number}  msgType
 * @param {number}  position
 * @param {string} cssClass
 * @param {Array} expressionList
 * @param {Date=} messageTimestamp
 * @return {number}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.addHistoricTranscript = function(id, msg, msgType, position, cssClass, expressionList, messageTimestamp) {
	/** @type {object} */
	var message = this.buildTranscriptMessage(this.historicTranscriptsArray, null, id, msg, msgType, position, false, cssClass, messageTimestamp);
	var res = this.historicTranscriptsArray.length - 1;
	message["msgId"] = com.inq.flash.client.chatskins.ChatTextArea.MSG_ID_PREFIX + res;
	this.prepareExpressionForRender(expressionList, message["msgId"]);
	this.historicTranscriptsArray.push(message);
	return res;
};

/**
 * Returns formatted time marker for message according to the settings specified in MXML file
 * @see com.inq.flash.client.chatskins.ChatTextArea.prototype.getDateFormatConfig
 * @param {Date} messageTimestamp
 * @return {string}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getTimeMarker = function(messageTimestamp) {
	return messageTimestamp.toLocaleTimeString(this.transcriptTimestampFormat["locales"], this.transcriptTimestampFormat["options"]);
};

/**
 * Builds transcript message to prepare it for rendering
 * @param {Array} transcriptArray
 * @param {?Array} previousTranscriptArray
 * @param {string}  id
 * @param {string}  msg
 * @param {number}  msgType
 * @param {number}  position
 * @param {boolean} messageExists indicates that we already the same message on this position
 *                                added by {@link ApplicationController.sendButtonClicked}
 * @param {string=} cssClass
 * @param {Date=} messageTimestamp
 * @return {Object}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.buildTranscriptMessage = function(transcriptArray, previousTranscriptArray, id, msg, msgType,
																						position, messageExists, cssClass, messageTimestamp) {
	var message = {};
	message["Id"] = id;
	message["Msg"] = msg;
	message["MsgType"] = msgType;
	message["position"] = position;
	if (cssClass) {
		message["cssClass"] = cssClass;
	}
	if (messageTimestamp && messageTimestamp instanceof Date) {
		message["messageTimestamp"] = messageTimestamp;
		message["timeMarker"] = this.getTimeMarker(messageTimestamp);
		if (messageExists) {
			message["newDay"] = transcriptArray[position]["newDay"]
		} else {
			message["newDay"] = this.getNewDayMarker(transcriptArray, previousTranscriptArray, messageTimestamp);
		}
	}
	return message;
};

/**
 * Determines and returns 'newDay' marker for async chat messages.
 * @param {Array} currentTranscriptArray
 * @param {?Array} previousTranscriptArray
 * @param {Date} messageTimestamp
 * @return {string} newDay marker
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getNewDayMarker = function(currentTranscriptArray, previousTranscriptArray, messageTimestamp) {
	/** @type {string} */
	var newDayMarker = "";
	try {
		if (com.inq.flash.client.chatskins.SkinControl.getApplicationController().getChat().isAsyncChat()
				&& this.isNewDay(currentTranscriptArray, previousTranscriptArray, messageTimestamp)) {
			var today = new Date();
			if (messageTimestamp.toLocaleDateString() === today.toLocaleDateString()) {
				newDayMarker = this.todayLabel;
			} else {
				newDayMarker = messageTimestamp.toLocaleDateString(this.transcriptDateFormat.locales, this.transcriptDateFormat.options);
			}
		}
	} catch (errWithMessage) {
		// The message seems wrong, we will use empty newDay as is.
		haxe.Log.trace("ChatTextArea.getNewDayMarker ERROR with timestamp(" + messageTimestamp + "), Detail: "
			+ Std.string(errWithMessage), {
			fileName: "ChatTextArea.hx",
			lineNumber: 424,
			className: "com.inq.flash.client.chatskins.ChatTextArea",
			methodName: "getNewDayMarker"
		});
	}
	return newDayMarker;
};

/**
 * RTDEV-20426
 * _isCustomerOrSystemMessage - method for the checking: is the last message on {position} and is it already
 * added previously into transcripts or no.
 * @param {number}  position
 * @return {Boolean}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype._isCustomerOrSystemMessage = function(position) {
	if (this.arrayTranscripts[position]) { // if the array item exists
		var entry = this.arrayTranscripts[position];
		return entry["position"] == -1 // the last added item wasn't restored from transcripts.
				&& (entry["MsgType"] == com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER
				|| entry["MsgType"] == com.inq.flash.client.chatskins.ChatTextArea.SYSTEM
				|| entry["MsgType"] == com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA);
	}
	return false;
};

/**
 * addOpenerScript
 *
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {string}  Id
 * @param {string}  Msg
 * @param {number}  MsgType
 * @param {number}  position
 * @param {Array} expressionList
 * @param {Date=}  messageTimestamp
 * @return {number} position
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.addOpenerScript = function(Id,Msg,MsgType,position, expressionList, messageTimestamp) {
	try {
		/** @type {object} */
		var openerMessage = this.buildTranscriptMessage(this.arrayOpeners, null, Id, Msg, MsgType,
			position, false, com.inq.flash.client.chatskins.ChatTextArea.OPENER_CLASS_NAME, messageTimestamp);

		/* position can be null/undefined. */
		if (position == undefined || position == -1) {
			if (this.arrayOpeners.length > 0 && this.arrayOpeners[this.arrayOpeners.length - 1]["Msg"] == Msg) {
				this.arrayOpeners.pop();
			}
			this.arrayOpeners.push(openerMessage);
			position = this.arrayOpeners.length - 1;
		} else {
			this.arrayOpeners[position] = openerMessage;
		}

		// openerMessage - it is the link to the object which was added to the arrayOpeners,
		// therefore we can continue to work with it and change it
		openerMessage["msgId"] = com.inq.flash.client.chatskins.ChatTextArea.OPENER_MSG_ID_PREFIX + position;

		this.prepareExpressionForRender(expressionList, openerMessage["msgId"]);
		this.render();
	} catch (e) {}
	return position;
};

com.inq.flash.client.chatskins.ChatTextArea.prototype.prepareExpressionForRender = function(list, msgId) {
	if (list && msgId) {
		for (var i = 0; i < list.length; i++) {
			switch (list[i]) {
				case com.inq.flash.client.data.MessageFields.CUSTOMER_NAME_INPUT_FIELD:
					this._inset[i] = new com.inq.ui.CustomerNameInputField(msgId);
					break;
			}
		}
	}
};

/**
 * clearTranscript
 *
 * $type TFun([],TEnum(Void,[]))
 * public function clearTranscript()
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.clearTranscript = function() {
	this._setHtmlText("");
	this._ta._addTranscriptToTable(this.__htmlText);
	this._wasCleared = true;
};

/**
 * Clears array transcript with current conversation
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.clearTranscriptArray = function() {
	this.arrayTranscripts.clear();
};

/**
 * Clears openers array
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.clearOpenersArray = function() {
	this.arrayOpeners.clear();
};

/**
 * Returns true if the chat window is scrolled to the bottom, or false in another cases
 *
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.isScrolledToBottom = function () {
	return this._ta ? this._ta.isScrolledToBottom() : false;
};

/**
 * scrollToEnd
 *
 * If non-customer's message received, autoScrollDisabled flag was set in skin file and
 * customer focus not at the bottom of the transcript, don't change
 * scroll position and show notification button
 *
 * Scroll the transcript to the end, so that the most recent
 * message shows.  This might mean scrolling to the top OR the
 * bottom of the transcript, depending on whether we're
 * top-posting or bottom-posting new messages.
 *
 * @public
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.scrollToEnd = function() {
	try {
		if (!this.atBottom && this.autoScrollDisabled && !this.isCustomerMessage(this.arrayTranscripts.length - 1)) {
			if (!this.isStatusMessage(this.arrayTranscripts.length - 1)) {
				// we want to show notification only when non-status message is received
				this.showScrollBtn();
			}
		} else {
			if (!this.reverseChat) {  /* If we're putting new lines at the bottom... */
				this.scrollToBottom(); /* ...scroll the transcript to the end         */
			}
			else {
				this.scrollToTop();    /* Otherwise, scroll to the top.               */
			}
			if (this._textArea != null) {
				if (this._textArea.getMaxScrollPosition().y > 0) {
					this._textArea._ta.style.overflowY = "scroll";
				}
			}
		}
	} catch(e) {
		haxe.Log.trace("Error scrolling text area:", { fileName : "ChatTextArea.hx", lineNumber : 504, className : "com.inq.flash.client.chatskins.ChatTextArea", methodName : "scrollToEnd"});
		haxe.Log.trace(e,{ fileName : "ChatTextArea.hx", lineNumber : 505, className : "com.inq.flash.client.chatskins.ChatTextArea", methodName : "scrollToEnd"});
	}
};

/**
 * Binds click event listener to the scrollBtn (presents if autoScrollDisabled flag was set in skin file).
 * We need it to scroll transcript to the bottom when customer clicks on scrollBtn.
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.bindListenerToScrollBtn = function() {
	if (this.scrollBtn) {
		this.scrollBtn.addEventListener(com.inq.events.MouseEvent.CLICK, function () {
			this.scrollToBottom();
			this.scrollBtn.setVisible(false);
		}.bind(this));
	}
};

/**
 * Binds scroll event listener to the chat window. We need it to hide scrollBtn
 * (presents if autoScrollDisabled flag was set in skin file) if customer scrolled
 * transcript to the bottom
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.bindListenerToChatWindow = function() {
	this._ta.addEventListener(com.inq.events.Event.SCROLL, function () {
		if (this.scrollBtn && this.scrollBtn.getVisible() && this._ta.isScrolledToBottom()) {
			this.scrollBtn.setVisible(false);
		}
	}.bind(this));
};

com.inq.flash.client.chatskins.ChatTextArea.prototype.showScrollBtn = function() {
	/** @type {string} */
	var chatBottomPosition = this._ta.getStyle("bottom");
	this.scrollBtn.setStyle("bottom", chatBottomPosition + "px");
	this.scrollBtn.setVisible(true);
};

/**
 * Returns true if transcript message is status message
 *
 * @param {number} index
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.isStatusMessage = function(index) {
	var message = this.arrayTranscripts[index];
	return message && message["MsgType"] === com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_STATUS;
};

/**
 * Returns true if transcript message sent by customer
 *
 * @param {number} index
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.isCustomerMessage = function(index) {
	var message = this.arrayTranscripts[index];
	return message && message["MsgType"] === com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER;
};

/**
 * RTDEV-15508
 * _resetRestoreChatState - private method for resetting the <restoreChatInProgress> variable defined in
 * MinimizeManaager.js. This variable is provided in order to prevent openerscript and transcript lines to be
 * announced when the "btnRestore" was re-displayed from the back button.
 * @private
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype._resetRestoreChatState = function() {
	com.inq.flash.client.control.MinimizeManager.restoreChatInProgress = false;
	this._resetRestoreChatTimer.stop();
	this._resetRestoreChatTimer = null;

};

/**
 * _render - private method for rendering the transcript area
 *
 * $type TFun([],TEnum(Void,[]))
 * private function _render():Void
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype._render = function() {
	try {
		this._renderTimer = null;
		this._setHtmlText(this.cachedHtml);
		this.disableInset();
		this.atBottom = this._ta.isScrolledToBottom();
		this._ta._addTranscriptToTable(this.__htmlText);
		com.inq.flash.client.chatskins.FontMgr.applyFontSizeAfterMsg(this._ta._div);
		this.renderInset();
		this.scrollToEnd();
		if (!com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			com.inq.flash.client.chatskins.SkinControl.setFocusOnCustomerNameInput();
		}
		if (!(com.inq.utils.Capabilities.isSafari() || com.inq.utils.Capabilities.isMobile())) {
			// RTDEV-14710 CATO Request
			if (Application.application.applicationController.intentionalDisconnect) {
				com.inq.aria.AriaUtil.hideTag( Application.application.getMxmlItem("chatWindow")._div, "a" );
			}
		}
	} catch( e ) {
		haxe.Log.trace(e,{ fileName : "ChatTextArea.hx", lineNumber : 480, className : "com.inq.flash.client.chatskins.ChatTextArea", methodName : "_render"});
	}
};

com.inq.flash.client.chatskins.ChatTextArea.prototype.renderInset = function() {
	for (var i = 0; i < this._inset.length; i++) {
		this._inset[i].show();
		this._inset[i].enableEventListener();
	}
};

com.inq.flash.client.chatskins.ChatTextArea.prototype.disableInset = function() {
	for (var i = 0; i < this._inset.length; i++) {
		this._inset[i].disableEventListener();
		this._inset[i].hide();
	}
};

/**
 * render - render the HTML into the text area
 * Render into a new text area and switch
 * Then delete the original text area
 *
 * Modified to remove the blinking on FireFox 3.6.3
 *
 * $type TFun([],TEnum(Void,[]))
 * private function render():Void
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.render = function() {
	/**
	 * RTDEV-15508
	 * This problem occurs when the user moves to different link when the chat is in minimized state. When this happens
	 * CI will invoke <actionMinimized> from <restoreChat> which will re-display the "btnRestore".  However, CI will
	 * also re-add the opener scripts and the transcripts back to ChatTextArea which will cause this problem.
	 * To fix this, problem we need to define a boolean variable in MinimizeManager to indicate the restore chat is
	 * happening.
	 *
	 */
	if (com.inq.flash.client.control.MinimizeManager.restoreChatInProgress) {
		/**
		 * RTDEV-15508
		 * <render> method is invoked before timer expires.  Reset the timer.
		 */
		if (this._resetRestoreChatTimer) {
			this._resetRestoreChatTimer.stop();
		}
		this._resetRestoreChatTimer = com.inq.utils.Timer.delay($bind(this, this._resetRestoreChatState), com.inq.flash.client.chatskins.ChatTextArea.RESET_RESTORA_CHAT_INPROGRESS_DELAY);
	}
	if (this._wasCleared) {
		return;
	}
	if(this._renderTimer != null) this._renderTimer.stop();
	/* delay the rendering of the page -> populate the entire
	 * chat transcript before displaying to avoid unnecessary
	 * renders and improve browser performance */

	/* RTDEV-21975 This check was made to exclude unnecessary re-rendering of the same transcript.
	*  Redundant render of transcript was the real cause of many issues related to focus wrong positioning. */
	this.cachedHtml = this.renderToHtml();
	if (this.cachedHtml == this.__htmlText) {
		return;
	}

	this._renderTimer = com.inq.utils.Timer.delay($bind(this,this._render),com.inq.flash.client.chatskins.ChatTextArea.RENDER_DELAY);
};

/**
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.isCustomerMsgExist = function () {
	for (var i = 0; i < this.arrayTranscripts.length; i++) {
		if (this.arrayTranscripts[i]["MsgType"] == 2) {
			return true;
		}
	}
};

/**
 * renderToHtml
 *
 * $type TFun([],TInst(String,[]))
 * private function renderToHtml():String
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {string}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.renderToHtml = function() {
	/** @type {Object} */
	var o;
	/** @type {string} */
	var htmlText = "";

	renderTranscripts.call(this, this.historicTranscriptsArray);

	for (var i = 0, l = this.arrayOpeners.length; i < l; i++) {
		o = this.arrayOpeners[i];
		if (null != o) try {
			htmlText = this.addTranscriptLine(o["Id"], o["Msg"], o["msgId"], o["MsgType"], htmlText, o["cssClass"], "");
			/**
			 * RTDEV-15508
			 * Only read openerscripts if we are not in restore chat state.
			 */
			if ((l === i + 1) && this.arrayTranscripts.length == 0 && com.inq.utils.Util.getConfig("readOpenerScript", true)
				&& !com.inq.flash.client.control.MinimizeManager.restoreChatInProgress) {
				com.inq.flash.client.chatskins.ChatTextArea.prototype.addBufferedAriaMsg(o["Id"], o["Id"] + " " + o["Msg"], o["MsgType"]);
			}
		} catch (e) {
		}
	}

	renderTranscripts.call(this, this.arrayTranscripts);

	return htmlText;

	/**
	 * Renders transcript array to the HTML text
	 * @param {Array} transcriptArray
	 * @this com.inq.flash.client.chatskins.ChatTextArea
	 */
	function renderTranscripts(transcriptArray) {
		for (var startIndex = 0; startIndex < transcriptArray.length; startIndex++) {
			/** @type {Object} */
			var message = transcriptArray[startIndex];
			if (message) {
				try {
					if ((!com.inq.utils.Util.isNullOrUndefined(message["Id"]) && message["Msg"]) || message["MsgType"] === com.inq.flash.client.chatskins.ChatTextArea.SEPARATOR) {
						htmlText = this.addTranscriptLine(
							message["Id"],
							message["Msg"],
							message["msgId"],
							message["MsgType"],
							htmlText,
							message["cssClass"],
							message["timeMarker"],
							message["newDay"]
						);
						// Only read the transcript line if we are not in restartChat state.
						if ((transcriptArray.length === startIndex + 1) && !com.inq.flash.client.control.MinimizeManager.restoreChatInProgress) {
							com.inq.aria.AriaMsg.addAriaMsg(message["Id"] + ": " + checkAI_HTML(message["Msg"]), message["MsgType"]);
						}
					}
				} catch (e) {
				}
			}
		}
	}

	/**
	 * RTDEV-14892 AI warps message in HTML element remove HTML element.
	 * @param testStr
	 * @returns {*}
     */
	function checkAI_HTML(testStr) {
		if(testStr.indexOf('sendVALinkClicked(event)') >= 0) {
			var resultArr = /.*sendVALinkClicked\(event\);">(.*)<\/div><\/span>/.exec(testStr);
			if (resultArr && resultArr.length === 2) {
				return resultArr[1];
			}
		} else if (testStr.indexOf('id="automaton_valink_') >= 0) { //CSP changed HTML
			var resultArr = /.*id="automaton_valink_.*">(.*)<\/div><\/span>/.exec(testStr);
			if (resultArr && resultArr.length === 2) {
				return resultArr[1];
			}
		}
		return testStr;
	}
};
/**
 * returns boolean value if we need to add newDay parameter to current message
 * @param {Array} currentTranscriptArray
 * @param {?Array} previousTranscriptArray
 * @param {Date} messageTimestamp - Date of current message
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.isNewDay = function(currentTranscriptArray, previousTranscriptArray, messageTimestamp) {
	/** @type {Date} */
	var prevMsgDate;
	if (currentTranscriptArray.length === 0) {
		if (previousTranscriptArray && previousTranscriptArray.length !== 0) {
			// last message of historic transcript array is always conversation separator
			prevMsgDate = previousTranscriptArray[previousTranscriptArray.length - 2]["messageTimestamp"];
		} else {
			return true;
		}
	} else {
		if (currentTranscriptArray[currentTranscriptArray.length - 1]["MsgType"] === com.inq.flash.client.chatskins.ChatTextArea.SEPARATOR) {
			// check if previous message is separator or not
			// previous message could be separator. In this case we take into account message before separator.
			prevMsgDate = currentTranscriptArray[currentTranscriptArray.length - 2]["messageTimestamp"];
		} else {
			prevMsgDate = currentTranscriptArray[currentTranscriptArray.length - 1]["messageTimestamp"];
		}
	}
	return !!prevMsgDate && messageTimestamp.toLocaleDateString() !== prevMsgDate.toLocaleDateString();
};

/**
 * Returns format of transcript date (transcript timestamp) from skin configuration if it is valid and default value otherwise
 * @param {object} defaultFormat
 * @param {string} propertyName
 * @return {object}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getDateFormatConfig = function(defaultFormat, propertyName) {
	/** @type{Object} only object expected */
	var date = com.inq.utils.Util.getConfig(propertyName, {});
	if (typeof date === "object" && (!!date.locales || !!date.options)) {
		return date;
	}
	return defaultFormat;
};

/**
 * setTabStops
 *
 * $type TFun([],TEnum(Void,[]))
 * private function setTabStops():Void
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.setTabStops = function() {
	try {
		/* trace("ChatTextArea.setTabStops") ; */
		/** @type {number} */
		var lmt = Math.floor(this._textArea.getWidth());
		if(lmt <= 0) lmt = this._indent + 500;
		this._tabStops = [];
		/** @type {number} */
		var ix = 0;
		/** @type {number} */
		var tab = this._indent;

		while(tab < lmt) {
			if(tab != 0) this._tabStops[ix++] = tab;
			tab += 10;
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ChatTextArea.setTabStops ERROR: " + Std.string(e),{ fileName : "ChatTextArea.hx", lineNumber : 392, className : "com.inq.flash.client.chatskins.ChatTextArea", methodName : "setTabStops"});
		} else throw(e);
	}
};


/**
 * getLength
 *
 * $type TFun([],TInst(Int,[]))
 * public function getLength():Int
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {number}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getLength = function() {
	return this._ta._getHtmlText().length;
};


/**
 * setIndent
 *
 * $type TFun([{ name => indent, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * public function setIndent(indent:Int):Void
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {number}  indent
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.setIndent = function(indent) {
	this._indent = indent;
	this.setTabStops();
};


/**
 * setGraphicId
 *
 * $type TFun([{ name => graphicID, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function setGraphicId(graphicID:Dynamic):Void
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {null}  graphicID
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.setGraphicId = function(graphicID) {
};


/**
 * applyStyles
 *
 * $type TFun([],TEnum(Void,[]))
 * private function applyStyles():Void
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.applyStyles = function() {
	/** @type {string} */
	var sFontSize;
	/** @type {string} */
	var sIndent;
	/** @type {string} */
	var sTabStops;
	/** @type {string} */
	var sFont;

	sFontSize = com.inq.flash.client.chatskins.SkinControl.transcriptFontSize;
	sIndent = com.inq.flash.client.chatskins.SkinControl.transcriptIndent;
	sTabStops = "[" + sIndent + "]";
	sFont = com.inq.flash.client.chatskins.SkinControl.transcriptFont;


	/** @type {com.inq.ui.StyleSheet} */
	var css = new com.inq.ui.StyleSheet();
	/** @type {com.inq.ui.TextArea} */
	var cw = Application.application.getMxmlItem("chatWindow");

	css.setStyle("html",{ });
	css.setStyle("body",{ fontFamily : sFont, fontSize : sFontSize, fontWeight : "normal"});

	/** @type {Object} */
	var styleObj;
	/** @type {string} */
	var styleId;
	/** @type {string} */
	var styleData;
	styleId = "systemMsg";
	styleData = com.inq.utils.Util.getConfig(styleId,null);

	if(styleData != null) {
		css.setStyle("." + styleId,styleData);
		styleId = "customerId";
		styleObj = com.inq.utils.Util.getConfig(styleId,null);

		if(styleObj != null) {
			styleObj["verticalAlign"] = "top";
			styleObj["vertical-align"] = "top";
		}
		css.setStyle("." + styleId,styleObj);
		styleId = "agentId";
		css.setStyle("." + styleId,com.inq.utils.Util.getConfig(styleId,null));

		styleId = "agentMsg";
		/*  get the sample string and get width in pixels */

		try {
			cw._setStyleSheet(css);
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
			} else throw(e);
		}

		styleObj = com.inq.utils.Util.getConfig(styleId,null);
		if(styleObj != null) {
			styleObj["tabStops"] = com.inq.flash.client.chatskins.SkinControl.transcriptTabStops;
			styleObj["marginLeft"] = sIndent;
		}
		css.setStyle("." + styleId,styleObj);
		styleId = "customerMsg";
		styleObj = com.inq.utils.Util.getConfig(styleId,null);
		if(styleObj != null) {
			styleObj["tabStops"] = sTabStops;
			styleObj["marginLeft"] = sIndent;
		}
		css.setStyle("." + styleId,styleObj);
		try {
			this._ta._setStyleSheet(css);
		} catch( e ) {
		}
	}
};


/**
 * exportData
 * save chat data when we change .mxml file
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {Object}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.exportData = function() {
	/** @type {Object} */
	var data = {
		__taId: this._textArea.getID(),
		__htmlText: this.__htmlText,
		_initialized: this._initialized,
		arrayOpeners: this.arrayOpeners.slice(),
		arrayTranscripts: this.arrayTranscripts.slice()
	};
	return data;
};


/**
 * importData
 *
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {Object}  data
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.importData = function(data) {
	/** @type {string} */
	var importedHtml = data["__htmlText"];
	this._setHtmlText(importedHtml);
	/** @type {string} */
	var taid = data["__taId"];/* Get the text area id from the JSON */
	this._initialized = data["_initialized"];/* Get the _initialized flag from the JSON */
	this.arrayOpeners = data["arrayOpeners"];/* get the Array openers */
	this.arrayTranscripts = data["arrayTranscripts"];/* get the transcript */
	if(this._ta == null) this._ta = this._textArea = Application.application.getMxmlItem(taid);
	if(this._ta != null) try {
		this._ta._addTranscriptToTable(importedHtml);
	} catch( e ) {
		haxe.Log.trace("importData ERROR: " + Std.string(e),{ fileName : "ChatTextArea.hx", lineNumber : 198, className : "com.inq.flash.client.chatskins.ChatTextArea", methodName : "importData"});
	} else haxe.Log.trace("Error: could NOT access the base textarea",{ fileName : "ChatTextArea.hx", lineNumber : 201, className : "com.inq.flash.client.chatskins.ChatTextArea", methodName : "importData"});


	this.scrollToBottom();
};


/**
 * scrollToTop
 *
 * $type TFun([],TEnum(Void,[]))
 * public function scrollToTop():Void
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.scrollToTop = function() {
	this._textArea.scrollToTop();
};


/**
 * Scrolls the transcript area to the bottom,
 * or to the top of the last message
 *
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.scrollToBottom = function() {
	if (this.enhancedScrollingEnabled && !this.isCustomerMessage(this.arrayTranscripts.length - 1)) {
		/** @type {HTMLCollectionOf<HTMLTableRowElement>} */
		var transcriptRows = this._ta._ta.getElementsByTagName("table")[0].rows;
		/** @type {HTMLTableRowElement} */
		var lastMessage = transcriptRows[transcriptRows.length - 1];
		this._textArea.scrollToPosition(new com.inq.utils.Point(0, lastMessage.offsetTop));
	} else {
		this._textArea.scrollToBottom();
	}
};


/**
 * setActualSize
 *
 * $type TFun([{ name => w, t => TInst(Float,[]), opt => false },{ name => h, t => TInst(Float,[]), opt => false }],TEnum(Void,[]))
 * public function setActualSize (w:Float, h:Float):Void
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {number}  w
 * @param {number}  h
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.setActualSize = function(w,h) {
};


/**
 * setHtmlText
 *
 * $type TFun([{ name => str, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function setHtmlText( str:Dynamic ):Void
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {null}  str
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.setHtmlText = function(str) {
	this._setHtmlText(str);
	this._textArea._addTranscriptToTable(this.__htmlText);
};


/**
 * _setHtmlText
 * Sets the value of this.__htmlText to the given string, without
 * altering the value or introducing other side effects.  Useful
 * for debugging where changes to __htmlText are coming from.
 *
 * $type TFun([{ name => htmlText, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private function _setHtmlText(htmlText:String):Void
 * @private
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {string}  htmlText - The new value of __htmlText.
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype._setHtmlText = function(htmlText) {
	this.__htmlText = htmlText;
};


/**
 * syncForms
 *
 * $type TFun([],TEnum(Void,[]))
 * public function syncForms()
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.syncForms = function() {
	/** @type {HTMLCollection} */
	var allForms = this._ta._div.getElementsByTagName("FORM");

	/* Set all updated values into the attribute tags of the forms */
	/** @type {HTMLCollection} */
	var inputs;
	for (var i = 0, len = allForms.length; i < len; i++) {
		inputs = allForms[i].getElementsByTagName("INPUT");
		for (var j = 0, inputLength = inputs.length; j < inputLength; j++) {
			inputs[j].setAttribute("value", inputs[j].value);
		}
	}

	/** @type {HTMLElement} */
	var divScratch = js.Lib.document.createElement("DIV");
	/** @type {number} */
	var findex = 0;
	for (var k = 0; k < this.arrayTranscripts.length; k++) {
		divScratch.innerHTML = this.arrayTranscripts[k]["Msg"];
		/** @type {HTMLCollection} */
		var frms = divScratch.getElementsByTagName("FORM");
		if (frms != null && frms.length > 0 && allForms.length > findex) {
			this.arrayTranscripts[k]["Msg"] = allForms[findex].parentNode.innerHTML;
			findex += frms.length;
		}
	}

	this.__htmlText = this.renderToHtml();
};


/**
 * setStyleSheet
 *
 * $type TFun([{ name => ss, t => TInst(com.inq.ui.StyleSheet,[]), opt => false }],TEnum(Void,[]))
 * public function setStyleSheet(ss:StyleSheet):Void
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @param {com.inq.ui.StyleSheet}  ss
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.setStyleSheet = function(ss) {
	return;
};


/**
 * getY
 *
 * $type TFun([],TInst(Float,[]))
 * public function getY():Float
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {number}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getY = function() {
	return this._textArea.getY();
};


/**
 * getX
 *
 * $type TFun([],TInst(Float,[]))
 * public function getX():Float
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {number}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getX = function() {
	return this._textArea.getX();
};


/**
 * getWidth
 *
 * $type TFun([],TInst(Float,[]))
 * public function getWidth():Float
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {number}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getWidth = function() {
	return this._textArea.getWidth();
};


/**
 * getHeight
 *
 * $type TFun([],TInst(Float,[]))
 * public function getHeight():Float
 * @public
 * @this com.inq.flash.client.chatskins.ChatTextArea
 * @return {number}
 */
com.inq.flash.client.chatskins.ChatTextArea.prototype.getHeight = function() {
	return this._textArea.getHeight();
};

com.inq.flash.client.chatskins.ChatTextArea.prototype.updateCustomerName = function(name) {
	if (this.arrayTranscripts.length > 0) {
		for (var i = 0; i < this.arrayTranscripts.length; i++) {
			var message = this.arrayTranscripts[i];
			if (message["MsgType"] == com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER) {
				message["Id"] = name;
			}
		}
		this.render();
	}
};

/** @private @type {boolean} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.reverseChat = null;
/** @private @type {com.inq.utils.Timer} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._renderTimer = null;
/** @private @type {boolean} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._initialized = null;
/** @type {null} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.htmlText = null;
/** @type {null} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.styleSheet = null;
/** @type {null} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.onInitialized = null;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.indent = null;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.y = null;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.x = null;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.width = null;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.height = null;
/** @private @type {null} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._onInitialized = null;
/** @private @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._indent = null;
/** @private @type {Array} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._tabStops = null;
/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.__htmlText = null;
/** @private @type {com.inq.ui.TextArea} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._ta = null;
/** @private @type {com.inq.ui.TextArea} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._textArea = null;
/** @private @type {com.inq.ui.TextField} */
com.inq.flash.client.chatskins.ChatTextArea.prototype._textField = null;
/** @private @type {Array} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.arrayOpeners = null;
/** @type {com.inq.flash.client.chatskins.ChatTextArea} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.__class__ = com.inq.flash.client.chatskins.ChatTextArea;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.RENDER_DELAY = 10;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.RESET_RESTORA_CHAT_INPROGRESS_DELAY = 2000;
/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.AGENT = 1;

/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER = 2;

/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.SYSTEM = 3;

/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_STATUS = 4;

/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.FORM_STATUS = 5;

/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_INFO = 6;

/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.SEPARATOR = 7;

/** @type {number} */
com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA = 8;

/** @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.OPENER_MSG_ID_PREFIX = "opener";

/** @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.MSG_ID_PREFIX = "msg";

/** @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.MESSAGE_ID_REPLACEMENT = "{{msgId}}";

/** @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.MSG_SFX = "</td></tr>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_CLASS_NAME = "tcChat_agentLine";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.VIRTUAL_AGENT_CLASS_NAME = "tcChat_virtualAssistantLine";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.LIVE_AGENT_CLASS_NAME = "tcChat_liveAgentLine";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.EXTERNAL_AGENT_CLASS_NAME = "tcChat_externalAgentLine";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AGENT_DEFAULT_CLASS_NAME = "tcChat_liveAgentLine";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.OPENER_CLASS_NAME = "tcChat_openerLine";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_PFX = "<tr><td class='" + com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_CLASS_NAME + "' style='vertical-align: top'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.AGENT_ID_SPAN = "<span class='agentId'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AGENT_ID_SFX = "&nbsp;</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AGENT_MSG_PFX = "<span class='agentMsg'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AGENT_MSG_SFX = "</span><div aria-hidden='true' class='msg-expression-inset' id='" + com.inq.flash.client.chatskins.ChatTextArea.MESSAGE_ID_REPLACEMENT + "'></div>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA_CLASS = "automaton-data-message";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA_MSG_PFX = "<span class=" + com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA_CLASS + ">";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA_ID_PFX = "<tr><td class=\"tcChat_" + com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA_CLASS + "\" style=\"vertical-align: top\">";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.CUST_ID_PFX = "<tr><td class='tcChat_customerLine' style='vertical-align: top'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.CUST_ID_SPAN = "<span class='customerId'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.CUST_ID_SFX = ":&nbsp;</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.CUST_MSG_PFX = "<span class='customerMsg'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.CUST_MSG_SFX = "</span></td></tr>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYS_PFX = "<tr><td><span class='systemMsg'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYS_SFX = "</span></td></tr>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYSSTAT_PFX = "<tr><td><span class='systemStatMsg'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYSSTAT_SFX = "</span></td></tr>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYSINF_PFX = "<tr><td class='systemInfo'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYSINF_ALIAS_PFX = "<span class='systemInfoAlias'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYSINF_ALIAS_SFX = "&nbsp;</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYSINF_MESSAGE_PFX = "<span class='systemInfoMsg'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.SYSINF_MESSAGE_SFX = "</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.SEPARATOR_TR = "<tr><td><div style='background-color: black; height: 1px'></div></td></tr>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.AGENT_MSG_TIME_PFX = "<span class='agentMsgTime'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.AGENT_MSG_TIME_SFX = "</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.TODAY_MSG_TIME_PFX = "<span class='todayMsgTime'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.TODAY_MSG_TIME_SFX = "</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.MSG_NEW_DAY_PFX = "<div class='msgDate'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.MSG_NEW_DAY_SFX = "</div>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.MSG_NEW_TODAY_DATE_DIV_PFX = "<div class='msgDate msgTodayDate'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.MSG_NEW_TODAY_DATE_DIV_SFX = "</div>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.MSG_NEW_TODAY_DATE_SPAN_PFX = "<span class='msgTodayDateSpan'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.MSG_NEW_TODAY_DATE_SPAN_SFX = "</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.CUST_MSG_TIME_PFX = "<span class='customerMsgTime'>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.CUST_MSG_TIME_SFX = "</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.PERIOD_PFX = "<span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.PERIOD_SFX = "</span>";

/** @private @type {string} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.TODAY_LABEL = "Today";

/** @private @type {object} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.defaultTranscriptTimestampFormat = {"locales": "en-US", "options": {"hour": "numeric", "minute": "numeric", "second": "numeric"}};

/** @private @type {object} */
com.inq.flash.client.chatskins.ChatTextArea.prototype.defaultTranscriptDateFormat = {"locales": "en-US", "options": {}};


